module.exports = __webpack_public_path__ + "img/carrot.93ab8459.svg";